// extracted by mini-css-extract-plugin
export default {"popup":"ModalBall_popup__SwhA3","popupContent":"ModalBall_popupContent__GHauA","popupText":"ModalBall_popupText__RUqCd"};